export default __webpack_public_path__ + "static/feature-flag-to-control-sessions-light-mode-1d8621f3e942ace38b8721822c991adf.png";